import DOMPurify from 'dompurify';
export const sanitizeHtmlContent = (rawHtml: string): string => {
    const parser = new DOMParser();
    try {
        // Check if the input is a valid HTML string
        parser.parseFromString(rawHtml, 'text/html');
    } catch (error) {
        console.error('Invalid HTML string:', error);
        return '';
    }

    const doc = parser.parseFromString(rawHtml, 'text/html');

    const contentOnly = doc.body.innerHTML;
    return DOMPurify.sanitize(contentOnly);
};
